import _ from 'lodash'

// Helper to create base column state for all presets
/* eslint-disable prettier/prettier */
// prettier-ignore
const createBaseColState = () => [
  { colId: 'selection', width: 40, hide: false, pinned: true, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'title', width: 300, hide: false, pinned: true, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'station', width: 110, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_time', width: 85, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'counts', width: 236, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_approved', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_type', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'status', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'source', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_date', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_tags', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'assignments', width: 300, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'reporter.name', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'videographer.name', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'manager.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'producer.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'editor.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'trt', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'summary', width: 300, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'location', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'live_source', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'live_type', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'id', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'share_count', width: 50, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'video_count', width: 70, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'end_date', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'created_at', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'created_by.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'deleted_at', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'logistics', width: 300, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'assignees', width: 300, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'end_time', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'is_highlight', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'parent_id', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null }
]
/* eslint-enable prettier/prettier */

// Helper to customize column state for specific presets
const customizeColState = (baseState, customizations) => {
  const state = _.cloneDeep(baseState)
  customizations.forEach(({ colId, ...props }) => {
    const col = state.find((c) => c.colId === colId)
    if (col) {
      Object.assign(col, props)
    }
  })
  return state
}

// Create preset templates
export const byDaypartTemplate = {
  name: 'By Daypart',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'story_type', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 2, hide: false }
  ])
}

export const byStatusTemplate = {
  name: 'By Status',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'status', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'reporter.name', hide: false }
  ])
}

export const bySourceTemplate = {
  name: 'By Source',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'source', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 2, hide: false },
    { colId: 'reporter.name', hide: false }
  ])
}

export const byCreatedTemplate = {
  name: 'By Created',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'created_by.name', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'source', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 2, hide: false }
  ])
}

export const byReporterTemplate = {
  name: 'By Reporter',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'reporter.name', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', hide: false }
  ])
}

export const byTagsTemplate = {
  name: 'By Tags Grouped',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'story_tags', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'story_type', sort: 'asc', sortIndex: 2, hide: false },
    { colId: 'source', sort: 'asc', sortIndex: 3, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 4, hide: false }
  ])
}

export const starterPackTemplates = [byDaypartTemplate, byStatusTemplate, bySourceTemplate, byCreatedTemplate, byReporterTemplate, byTagsTemplate]
